import {
  ArrayControlProps,
  isControl,
  rankWith,
  resolveSchema,
} from "@jsonforms/core";
import { withJsonFormsArrayControlProps } from "@jsonforms/react";
import { ColDef } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { useMemo } from "react";
import { columnTypes } from "../Grid/ColumnTypes";
import { baseGridComponents } from "../Grid/gridComponents";
import { useProcessedColumnDefs } from "../Grid/useProcessedColumnDefs";

const GridRenderer = (props: ArrayControlProps) => {
  const data = useMemo(() => (Array.isArray(props.data) ? props.data : []), [
    props.data,
  ]);

  const rawDefs = useMemo<ColDef[]>(() => {
    if (
      !props.schema ||
      props.schema.type !== "object" ||
      !props.schema.properties
    ) {
      return [];
    }

    return props?.uischema?.options?.columnDefs
      ? props.uischema.options.columnDefs
      : Object.entries(props.schema.properties).map(
          ([field, propSchema]: [string, any]) => ({
            field,
            headerName: propSchema.title ?? field,
            context: propSchema.context,
            sortable: false,
            filter: false,
            resizable: true,
            flex: 1,
          }),
        );
  }, [props.schema, props?.uischema?.options?.columnDefs]);

  const columnDefs = useProcessedColumnDefs(rawDefs);

  if (data.length === 0) {
    return (
      <div className="group-container">
        <div className="no-data">Nothing to display</div>
      </div>
    );
  }

  return (
    <div className="group-container">
      <div className="GridRenderer ag-theme-alpine">
        <AgGridReact
          rowData={data}
          columnDefs={columnDefs}
          domLayout="autoHeight"
          columnTypes={columnTypes}
          components={baseGridComponents}
        />
      </div>
    </div>
  );
};

export const gridRendererTester = rankWith(100, (uischema, schema, context) => {
  if (!isControl(uischema)) return false;
  if (uischema.options?.variant !== "grid") return false;

  const resolvedSchema = resolveSchema(
    schema,
    uischema.scope,
    context?.rootSchema,
  );

  return resolvedSchema?.type === "array";
});

export default withJsonFormsArrayControlProps(GridRenderer);
